<template lang="html">
  <v-button class="buttom-dropdown" :to="to" @click="click">
    <slot></slot>
  </v-button>
</template>

<script>
export default {
  methods: {
    click() {
      this.$emit('click');
    },
  },
  props: ['badge', 'to'],
};
</script>

<style lang="scss">
.button.buttom-dropdown {
  color: #000;
  width: 100%;
  border-radius: 0;
  white-space: nowrap;
  .button-inner {
    display: flex;
    justify-content: start;
    padding: 0;

    .icon {
      font-size: 1.3em;
      margin-right: 0.3em;
      color: gray(400);
    }
    .badge {
      margin-left: auto;
      background: black(0.1);
      font-size: 12px;
      line-height: 1em;
      text-align: center;
      padding: 4px;
      min-width: 20px;
      height: 20px;
      border-radius: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/modules/button-dropdown.vue